// src/modules/settings/customers/components/CustomerDialogs.tsx
import React from "react";
import CustomerForm from "./CustomerForm";
import { CustomerData } from "../types/customerTypes";
import DeleteCustomer from "../deletecustomer/DeleteCustomer";
import EditCustomer from "../EditCustomer/components/EditCustomer";

interface CustomerDialogsProps {
  isEditOpen: boolean;
  isDeleteOpen: boolean;
  isAddOpen: boolean;
  selectedCustomer: CustomerData | null;
  onCloseEdit: () => void;
  onCloseDelete: () => void;
  onCloseAdd: () => void;
  onAddCustomer: (customerData: Partial<CustomerData>) => void;
  onRefetch: () => void;
  onResetSelection: () => void;
}

const CustomerDialogs: React.FC<CustomerDialogsProps> = ({
  isEditOpen,
  isDeleteOpen,
  isAddOpen,
  selectedCustomer,
  onCloseEdit,
  onCloseDelete,
  onCloseAdd,
  onAddCustomer,
  onRefetch,
  onResetSelection,
}) => {
  return (
    <>
      {isEditOpen && selectedCustomer && (
        <EditCustomer
          id={selectedCustomer._id.$oid}
          name={selectedCustomer.Name}
          phone={selectedCustomer.phone_number}
          alternativephone={selectedCustomer.alternativenumber}
          email={selectedCustomer.Email}
          address={selectedCustomer.Address?.street || selectedCustomer.Address?.customeraddress1 || ""}
          address2={selectedCustomer.Address?.street2 || selectedCustomer.Address?.customeraddress2 || ""}
          address3={selectedCustomer.Address?.street3 || selectedCustomer.Address?.customeraddress3 || ""}
          closeEditcustomer={() => {
            onCloseEdit();
            onResetSelection();
          }}
          refreshCustomerList={onRefetch}
        />
      )}

      {isDeleteOpen && selectedCustomer && (
        <DeleteCustomer
          id={selectedCustomer._id.$oid}
          name={selectedCustomer.Name}
          refreshCustomerList={onRefetch}
          outStandingBalance={selectedCustomer.Out_standing_balance}
          onClose={() => {
            onCloseDelete();
            onResetSelection();
          }}
        />
      )}

      <CustomerForm open={isAddOpen} onClose={onCloseAdd} onSubmit={onAddCustomer} />
    </>
  );
};

export default CustomerDialogs;
